<template>
    <div class="flex flex-row gap-4 justify-end">
        <button
            v-if="showEdit"
            @click="$emit('edit')"
            class="icon-edit"
        >
            <span class="material-symbols-outlined hidden sm:block sm:text-3xl sm:w-9 sm:h-9 sm:m-0">edit</span>
            <span class="sm:hidden">{{ $t('common.edit') }}</span>
        </button>
        <button
            v-if="showDelete"
            @click="$emit('delete')"
            class="icon-delete"
        >
            <span class="material-symbols-outlined hidden sm:block sm:text-3xl sm:w-9 sm:h-9 sm:m-0">delete_forever</span>
            <span class="sm:hidden">{{ $t('common.delete') }}</span>
        </button>
    </div>
</template>

<script>
// Edit / Delete buttons shown in the actions column of a table row
export default {
    props: {
        showEdit: {
            type: Boolean,
            default: true,
        },
        showDelete: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['edit', 'delete'],
};
</script>
